import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFetch } from '@rad/hooks';
import { mapPromise } from '@rad/utility/promise';
import createTable from '@rad/components/ui/table';
import { getAudit, diffAuditTrail } from '../../types';
import UserTimestamp from '../../components/user-timestamp';
const Value = (props) => {
    return _jsx("span", { className: props.className, children: props.value === undefined || props.value === null ? _jsx(_Fragment, { children: "\u2013" }) : props.value.toString() });
};
const Patch = (props) => {
    return _jsxs(_Fragment, { children: [props.diff.removed.map((x) => _jsxs("div", { children: [x.path, ": ", _jsx(Value, { value: x.before, className: "text-decoration-line-through" })] }, `removed ${x.path}`)), props.diff.added.map((x) => _jsxs("div", { children: [x.path, ": ", _jsx(Value, { value: x.after, className: "fw-bold" })] }, `added ${x.path}`)), props.diff.changed.map((x) => _jsxs("div", { children: [x.path, ": ", _jsx(Value, { value: x.before, className: "text-decoration-line-through" }), " \u2192 ", _jsx(Value, { value: x.after, className: "fw-bold" })] }, `changed ${x.path}`))] });
};
export const AuditTable = (props) => {
    const [data, _reload] = useFetch(getAudit(props.kind, props.id));
    const AuditTable = createTable(mapPromise(data, (x) => diffAuditTrail(x)));
    return _jsx(_Fragment, { children: _jsx(AuditTable, { title: props.title || 'Audit Log', columns: [
                { 'header': 'Event', 'render': (x) => _jsxs(_Fragment, { children: [x.value.action, " ", _jsx(UserTimestamp, { user_id: x.value.performed_by, timestamp: x.value.occurred })] }) },
                { 'header': 'Details', 'render': (x) => _jsx(Patch, { diff: x }) },
            ] }) });
};
export default AuditTable;
